import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Power } from "lucide-react";
import { clearAuthCookies } from "../../../../Utils/authUtils";

const Header = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  const handleLogout = () => {
    clearAuthCookies();
    navigate("/", { replace: true });
  };

  useEffect(() => {
    const userCookie = Cookies.get("user");

    if (userCookie) {
      setUser(JSON.parse(userCookie));
    }
  }, []);

  const userName = user?.name || "Employee";

  const getInitials = (name) => {
    if (!name) return "E";

    const parts = name.trim().split(" ");

    if (parts.length === 1) {
      return parts[0][0].toUpperCase();
    }

    return parts[0][0].toUpperCase() + parts[parts.length - 1][0].toUpperCase();
  };

  const location = useLocation();
  const path = location.pathname;

  const getPageName = () => {
    if (path === "/home") {
      return "Welcome to Dashboard";
    }

    const segments = path.split("/").filter(Boolean);

    let last = segments[segments.length - 1];

    const isUUID = /^[0-9a-fA-F-]{36}$/.test(last);
    const isNumber = !isNaN(last);

    if ((isUUID || isNumber) && segments.length > 1) {
      last = segments[segments.length - 2];
    }

    return last.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const initial = getInitials(userName);
  return (
    <div className="h-16 bg-white border-b flex items-center justify-between px-6">
      {/* LEFT */}
      <div className="flex items-center gap-5">
        <img
          src="/OPT4CRM-LOGO.svg"
          alt="logo"
          className="h-9 object-contain"
        />

        <h1 className="text-lg font-semibold">{getPageName()}</h1>
      </div>

      {/* RIGHT */}
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-3 bg-gray-100 px-3 py-1.5 rounded-full">
          <div className="w-9 h-9 bg-blue-500 text-white flex items-center justify-center rounded-full text-sm font-medium">
            {initial}
          </div>

          <span className="text-sm font-medium text-gray-700 whitespace-nowrap">
            {userName}
          </span>
        </div>

        <button
          title="Logout"
          onClick={handleLogout}
          className="w-9 h-9 flex items-center justify-center rounded-full text-gray-500 hover:bg-red-50 text-red-500 transition-all duration-200"
        >
          <Power size={20} />
        </button>
      </div>
    </div>
  );
};

export default Header;
